import $ from 'jquery';
/**
 * Created by Kamil.Adamuszek on 2017-04-14.
 */
/**
 * Validation method that test if the field is valid against a minimum length of string.
 */
export var minLength = function (value, element) {
    var minValue = $(element).data('min_length');
    if (value.length >= minValue) {
        return true;
    }
    else {
        return false;
    }
};
